// Message Managment Reducer

const messageManagmentDefaultState = {
  login : { 
    display : false,
    text : 'test',
  }
};

export default (state = messageManagmentDefaultState, action) => {
  switch (action.type) {
    case 'SET_MESSAGE':
      return {
        ...state,
        login: action.data.login
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/messageManagment.js